"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _editableMode = _interopRequireDefault(require("./editable-mode"));
if (require('exenv').canUseDOM) require('./index.scss');
class EditorNew extends _react.default.Component {
  render() {
    const _this$props = this.props,
      decorator = _this$props.decorator,
      mobilization = _this$props.mobilization,
      settings = _this$props.widget.settings;
    const bodyFont = mobilization.body_font;
    const theme = mobilization && mobilization.color_scheme ? mobilization.color_scheme.replace('-scheme', '') : null;
    let value;
    try {
      value = JSON.parse(settings.content);
    } catch (e) {
      value = settings.content;
    }
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "widgets--content-plugin widget editor-new",
      style: {
        fontFamily: bodyFont
      }
    }, /*#__PURE__*/_react.default.createElement(_editableMode.default, {
      readOnly: true,
      value: value,
      theme: theme
    }));
  }
}
var _default = exports.default = EditorNew;